import { useState } from 'react';

const CONSENT_KEY = 'cookie_consent_accepted';

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(CONSENT_KEY));

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50"
      style={{ borderTop: '1px solid var(--color-border)', backgroundColor: 'var(--color-background)' }}
    >
      <div className="container-wide py-3 flex items-center justify-between gap-4">
        <p className="text-xs text-muted m-0 leading-relaxed">
          This site uses cookies and collects analytics data (pages visited, device info, IP-based
          location) to improve the experience. By continuing to browse, you accept this.
        </p>
        <button
          onClick={accept}
          className="btn-terminal-primary text-xs whitespace-nowrap shrink-0"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
